import { useContext, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { IBarring } from "../interface/IBarrings";
import { getBarringRoute, postBarringRoute } from "@api-routes";
import { getResponseToState, IBarringListResponse } from "../mappers/getBarringListMapper";
import { useFetch } from "@common/hook/useFetch";
import { getLanguage } from "@utils/changeLanguage";

export const useBarringList = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [barringList, setBarringList] = useState<IBarring[]>([]);
    const [getBarringListState, { get }] = useFetch();
    const [postBarringState, { post }] = useFetch();
    const lang = getLanguage();

    const getBarringList = () => {
        if (selectedService) {
            get<IBarringListResponse>(getBarringRoute(selectedService.id, lang)).then((barringListResponse) => {
                if (barringListResponse) {
                    setBarringList(getResponseToState(barringListResponse));
                }
            });
        }
    };

    const postBarring = (
        barringCode: string,
        action: string,
        status: boolean,
        setCheckStatus: (val: boolean) => void
    ) => {
        if (selectedService) {
            post<boolean>(postBarringRoute(selectedService.id), {
                body: { barringCode: barringCode, action: action },
            }).then((postBarringResponse) => {
                if (postBarringResponse) {
                    setCheckStatus(status);
                }
            });
        }
    };

    return { getBarringListState, barringList, getBarringList, postBarring, postBarringState };
};
